import * as tslib_1 from "tslib";
import { FormField } from '../form_field';
var DisplayField = /** @class */ (function (_super) {
    tslib_1.__extends(DisplayField, _super);
    function DisplayField(param) {
        var _this = _super.call(this, param) || this;
        var obj;
        if (typeof param === 'string') {
            obj = JSON.parse(param);
        }
        else {
            obj = param;
        }
        if (!obj) {
            return _this;
        }
        var keys = 'displayTemplate';
        Object.keys(obj).forEach(function (key) {
            if (keys.includes(key)) {
                _this[key] = obj[key];
            }
        });
        return _this;
    }
    DisplayField.prototype.toJSON = function () {
        return Object.assign({}, _super.prototype.toJSON.call(this), { "displayTemplate": this.displayTemplate, "type": "DisplayField" });
    };
    DisplayField.prototype.toString = function () {
        return JSON.stringify(this.toJSON());
    };
    return DisplayField;
}(FormField));
export { DisplayField };
//# sourceMappingURL=display_field.js.map